<template lang="pug">

#landscape(v-if="show")
  .bg 
  .iconWrapper
    .icon
      icon-rotate
  p.copy( v-html="copy" )
  .header
    logo-svg



</template>

<script>

import IconRotate from '@/assets/svgs/rotate-icon.svg' 
import LogoSvg from '@/assets/svgs/RightCar_logo.svg'
import Env from '@/config/env'

export default {
 
  components: {
    IconRotate, 
    LogoSvg
  },

  data() {
    return { }
  },

  computed: {
    
    copy(){
      return this.lang_en['site-rotate-screen-copy']
    },

    show(){ 
      return (Env.mobile || Env.tablet)
    }

  },

  mounted() {},
} 
</script>

<style lang="sass">
@import "src/styles/common.sass"

#landscape
  +full()
  width: 100vw
  height: 100vh
  +user-select(none)
  +flex-center()
  pointer-events: none 
  color: white
  text-align: center
  display: none
  flex-direction: column

  @media screen and (orientation:portrait)
    .tablet &
      display: flex !important
      pointer-events: all
      z-index: 10000

  @media screen and (orientation:landscape)
    .mobile &
      display: flex !important
      pointer-events: all
      z-index: 10000

  .copy
    margin-top: 1.5rem
    position: relative
    font-family: "Regular"
    font-size: 1.2rem
    z-index: 1

    .dark
      color: #373C85

  .bg
    +full()
    background-size: cover
    background-position: center
    background-image: url('~@/assets/imgs/rotate_screen_bg.png')

  .header
    width: 100%
    height: 2rem
    top: 3.2rem
    position: absolute

    svg
      width: 100%
      height: 100%

      .car_bg,
      .car_font,
      .car_left,
      .car_right
        fill: #FFFFFF 

  .iconWrapper
    z-index: 1
    +flex-center() 
    width: 4.9rem
    height: 4.9rem
    margin-top: 2rem
    transform-origin: 50% 50%
    animation: spin 3s cubic-bezier(0.645, 0.045, 0.355, 1) infinite

    .icon
      height: 4.9rem

      svg
        height: 100%
        overflow: auto

        #phoneScreenBg
          fill: #f9f9f9
 


@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)
</style>
